import { Accion, AccionEjecutar } from '../types'
import { BaseResponse } from 'src/types'
import { HttpAxiosRequest } from 'src/http/httpAxiosBase'
import { SistemaTipo } from "../../../types/enum/enum";
import { getComentarios } from './get-comentarios'
import { getComentariosTipos } from './get-comentarios-tipos'
import { postComentario } from './post-comentario'
import { postArchivo } from './post-archivo'
import { getArchivos } from './get-archivos'
import { getArchivoTipos } from './get-archivo-tipos'
import { getFirmas } from './get-firmas'
import { putFirma } from './put-firma'
import { rutaPorCodSistema } from '../RefactorLayout';

const getEndpoint = (url = ''): string => `workflow/${url}`

export const getEndpointBySistema = (codSistema: SistemaTipo) => {
    return `operaciones/${rutaPorCodSistema[codSistema]}`
}

export const HttpSistema = {
    getAcciones: (idEtapa: number): Promise<Accion[]> => {
        return HttpAxiosRequest.get(getEndpoint(`acciones/${idEtapa}`))
    },

    ejecutarAccion: (idMensaje: number, accionEjecutar: AccionEjecutar): Promise<BaseResponse> => {
        return HttpAxiosRequest.post(getEndpoint(`mensaje/${idMensaje}/ejecutar`), accionEjecutar)
    },

    getComentarios: getComentarios,
    getComentariosTipos: getComentariosTipos,
    postComentario: postComentario,
    postArchivo: postArchivo,
    getArchivos: getArchivos,
    getArchivoTipos: getArchivoTipos,
    getFirmas: getFirmas,
    putFirma: putFirma
} as const
